import React, { useState } from "react"
// import Autocomplete from "./Autocomplete";
import "./App.css"
import AutoTypingPad from "./AutoTypingPad";
// import AutocompleteV3 from "./AutocompleteV3";

function App() {
  // const [selectedVersion, setSelectedVersion] = useState("autocompleteV1");

  return (
    <div className="text-center">
      {/* <h1 className="text-3xl mb-5 text-white font-bold bg-zinc-700 py-3 pr-2">Typing Pad: {selectedVersion === "autocompleteV1" ? "Character" : "Words"} </h1> */}
      <h1 className="text-3xl mb-5 text-white font-bold bg-zinc-700 py-3 pr-2">Typing Pad </h1>


      {/* <div className="flex flex-row space-x-4 items-center justify-center py-3">
        <label className="flex items-center space-x-2">
          <input
            type="radio"
            name="autocomplete"
            value="autocompleteV1"
            checked={selectedVersion === "autocompleteV1"}
            onChange={() => setSelectedVersion("autocompleteV1")}
            className="h-6 w-6 text-blue-500 focus:ring-blue-500"
          />
          <span className="text-gray-800">Characters</span>
        </label>

        <label className="flex items-center space-x-2">
          <input
            type="radio"
            name="autocomplete"
            value="autocompleteV2"
            checked={selectedVersion === "autocompleteV2"}
            onChange={() => setSelectedVersion("autocompleteV2")}
            className="h-6 w-6 text-blue-500 focus:ring-blue-500"
          />
          <span className="text-gray-800">Words</span>
        </label>
      </div> */}
      {/* <Autocomplete suggestions={[
        "Alligator",
        "Bask",
        "Crocodilian",
        "Death Roll",
        "Eggs",
        "Jaws",
        "Reptile",
        "Solitary",
        "Tail",
        "Wetlands"
      ]}
      /> */}

      <AutoTypingPad />
      {/* {selectedVersion === "AutoTypingPad" && <AutocompleteV3 />} */}
    </div>
  );
}


export default App;
